// alterado - revisado

import React from 'react'

import { 
    TextField,
} from '@material-ui/core'

import {
    STYLE
} from '../../business-const/Style/Style'

export const TextFieldBase = props => {

    const { desejavel, report, ...rest } = props

    return (
        <TextField
            className="mt-2 mb-2 w-full"
            size="medium"
            variant="outlined"
            InputProps={{
                style: STYLE(false, report ? false : rest.disabled).styleTextField
            }}
            InputLabelProps={{
                style: rest.value || rest.value === 0 ? STYLE(false, rest.disabled).styleLabelTextFieldWithValue : STYLE(false, rest.disabled).styleLabelTextField
            }}
            FormHelperTextProps={{
                style:
                    desejavel
                        ?
                            STYLE(false, rest.disabled).styleHelperTextDesejavel
                        :
                            STYLE(false, rest.disabled).styleHelperText
            }}
            {...rest}
        />
    )
}

export const TextFieldText = props => {

    return (
        <TextFieldBase
            type="text"
            multiline={true}
            {...props}
        />
    )
}

export const TextFieldTextTable = props => {
    return (
        <TextFieldText
            className=""    
            fullWidth
            {...props}
        />
    )
}

export const TextFieldNumber = props => {
    return (
        <TextFieldBase
            type="number"
            {...props}
        />
    )
}

export const TextFieldNumberTable = props => {
    return (
        <TextFieldNumber
            className=""    
            fullWidth
            {...props}
        />
    )
}